import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { ChevronRight } from 'lucide-react';

export const CategoryCard = ({ category }) => {
  return (
    <Link to={`/category/${category.id}`}>
      <Card className="group overflow-hidden hover:shadow-elegant transition-smooth h-full">
        <div className="relative aspect-[4/3] overflow-hidden bg-gradient-subtle">
          {(category.image_url || category.image) ? (
            <img
              src={category.image_url || category.image}
              alt={category.name}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center">
              <span className="text-5xl text-primary/20 font-serif">{category.name[0]}</span>
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <h3 className="font-serif text-2xl font-bold text-white mb-2">
              {category.name}
            </h3>
            {category.description && (
              <p className="text-sm text-white/90 line-clamp-2">
                {category.description}
              </p>
            )}
          </div>
        </div>
        <CardContent className="p-4">
          <div className="flex items-center justify-between text-primary group-hover:text-primary-hover transition-smooth">
            <span className="text-sm font-medium">Explore Products</span>
            <ChevronRight className="w-4 h-4" />
          </div>
        </CardContent>
      </Card>
    </Link>
  );
};